
/**
 * find a parent element which has given attribute key
 * @param {*} el 
 * @param {*} attr 
 */
export function findParentHasAttribute(el, attr) {
  let found = el;
  while(found !== null && !found.hasAttribute(attr)) {
    found = found.parentElement || found.parentNode;
  }
  return found;
}